module.exports = __webpack_public_path__ + "static/media/progress_bar_3.21ebb1d8.svg";